export default __webpack_public_path__ + "static/media/image-cushion-b-w@2x.196cd950.webp";